<template>
  <div class="overflow-x-hidden bg-neutral-50">
    <Head :title="$t('specialisations.title')" />

    <div class="mx-auto w-full min-w-0 max-w-[1200px] px-4 py-8 sm:px-6 lg:px-0">
      <!-- Breadcrumb -->
      <nav class="mb-6 flex min-w-0 flex-wrap items-center gap-1 text-sm text-neutral-700" aria-label="Breadcrumb">
        <Link :href="homeHref" class="shrink-0 text-neutral-700 hover:text-[#2ea8cf]">
          {{ $t('breadcrumbs.home') }}
        </Link>
        <span class="shrink-0 text-neutral-300" aria-hidden="true">/</span>
        <span class="text-[#2ea8cf]">{{ $t('breadcrumbs.specialisations') }}</span>
      </nav>

      <!-- Page title -->
      <h1 class="text-[32px] font-medium leading-10 tracking-[-0.02em] lg:text-[40px] lg:leading-[48px]">
        {{ $t('specialisations.title') }}
      </h1>

      <!-- Cards grid -->
      <div v-if="specialisations.length > 0" class="mt-8 lg:mt-10">
        <div class="grid min-w-0 grid-cols-2 gap-3 sm:gap-6 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
          <Link
            v-for="specialisation in specialisations"
            :key="specialisation.id"
            :href="specialisationHref(specialisation)"
            class="flex min-h-[72px] min-w-0 items-center rounded-xl bg-white px-3 py-3 no-underline shadow-[0px_2px_6px_0px_rgba(16,24,40,0.06)] transition-all hover:shadow-[0px_4px_12px_0px_rgba(16,24,40,0.12)] sm:px-4 lg:py-3"
          >
            <p class="min-w-0 break-words font-sans text-sm font-semibold leading-5 text-dark sm:text-base sm:leading-6">
              {{ specialisation.name }}
            </p>
          </Link>
        </div>
      </div>

      <div v-else class="py-16 text-center">
        <h3 class="text-sm font-semibold text-neutral-900">{{ $t('specialisations.empty_title') }}</h3>
        <p class="mt-1 text-sm text-neutral-500">
          {{ $t('specialisations.empty_hint') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';

export default {
  name: 'SpecialisationsIndex',
  components: { Head, Link },
  props: {
    specialisations: { type: Array, default: () => [] },
    // eslint-disable-next-line vue/prop-name-casing
    site_context: { type: String, default: null },
    // eslint-disable-next-line vue/prop-name-casing
    site_context_label: { type: String, default: '' },
  },
  computed: {
    homeHref() {
      const ctx = this.site_context;
      if (ctx && ctx !== 'code_medical_center' && this.$routes[ctx]) {
        return this.$routes[ctx]();
      }
      return '/';
    },
  },
  methods: {
    specialisationHref(specialisation) {
      return this.$routes.specialisation(specialisation.slug);
    },
  },
};
</script>
